import { render, staticRenderFns } from "./CounterDesign.vue?vue&type=template&id=e5d0607a"
import script from "./CounterDesign.vue?vue&type=script&lang=js"
export * from "./CounterDesign.vue?vue&type=script&lang=js"
import style0 from "./CounterDesign.vue?vue&type=style&index=0&id=e5d0607a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports